export default __webpack_public_path__ + "static/media/completed.d791c650.svg";